import { Reducer, useReducer } from 'react'
import { useHistory } from 'react-router'
import { getDocumentPreview } from '../services/Kyc'
import { handleError } from '../services/utils'
import { TDocumentReducerAction } from '../interfaces/Modal'

function useDocumentsModal() {
  const history = useHistory()

  const initialState = {
    openDocumentModal: false,
    documentsPreviewUrl: [''],
    refreshDocumentsState: false,
    previewIsLoading: false,
  }

  const reducer: Reducer<typeof initialState, TDocumentReducerAction> = (
    state,
    action
  ) => {
    switch (action.type) {
      case 'previewIsLoading':
        return { ...state, previewIsLoading: true }
      case 'previewIsLoaded':
        return { ...state, previewIsLoading: false }
      case 'openDocumentModal':
        return { ...state, openDocumentModal: true }
      case 'closeDocumentsModal':
        return { ...state, openDocumentModal: false }
      case 'handleNextStep':
        return {
          ...state,
          openDocumentModal: true,
          refreshDocumentsState: false,
        }
      case 'handleModalReUpload': {
        return {
          ...state,
          refreshDocumentsState: true,
          openDocumentModal: false,
        }
      }
      case 'refreshDocumentsState':
        return { ...state, refreshDocumentsState: true }
      case 'resetDocumentsState':
        return { ...state, refreshDocumentsState: false }
      case 'resetDocumentsPreviewUrl':
        return { ...state, documentsPreviewUrl: [] }
      case 'updateDocumentsUrl':
        return {
          ...state,
          documentsPreviewUrl: [...state.documentsPreviewUrl, action.payload],
        }
      default:
        throw new Error()
    }
  }
  const [deleteDocumentsReducerState, dispatch] = useReducer(
    reducer,
    initialState
  )

  const getDocumentPreviews = async (
    documentUid: string,
    isVerso: boolean = false
  ) => {
    try {
      const insertResponse = await getDocumentPreview(documentUid, isVerso)
      const file = await insertResponse.blob()
      const fileUrl = URL.createObjectURL(file)
      dispatch({
        type: 'updateDocumentsUrl',
        payload: fileUrl,
      })
    } catch (error) {
      handleError(error, history)
    }
  }

  return { deleteDocumentsReducerState, dispatch, getDocumentPreviews }
}

export default useDocumentsModal
